import { render } from "./NoticeNew.vue?vue&type=template&id=9335c208&scoped=true"
import script from "./NoticeNew.vue?vue&type=script&lang=js"
export * from "./NoticeNew.vue?vue&type=script&lang=js"

import "./NoticeNew.vue?vue&type=style&index=0&id=9335c208&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9335c208"]])

export default __exports__